import onboarding from './onboardingMiddleware';

export default [onboarding];
